import React, { Component } from 'react';

class ZipCodeField extends Component {
    constructor(props) {
        super(props);

        this.handleZipCodeChange = this.handleZipCodeChange.bind(this);
    }

    handleZipCodeChange(event) {
        // Trigger the redux-form onChange callback.
        this.props.input.onChange(event.currentTarget.value);
    }

    render() {
        const { meta: { touched, error } } = this.props;
        let errorClassName = '';
        if (touched && error) {
            errorClassName = 'has-error ';
        }

        const codeOptionsMarkup = this.props.zipcodes.map((code, idx) => (
            <option key={idx} value={code}>
                {code}
            </option>
        ));

        return (
            <div style={{ position: 'relative' }} className={`${errorClassName}`}>
                <select
                    name={`${this.props.fieldNamePrefix}[zipcode]`}
                    onChange={this.handleZipCodeChange}
                    className="form-control primary-input-field"
                    value={this.props.input.value}
                >
                    { codeOptionsMarkup }
                </select>
                {touched && error && <span className="help-block">{error}</span>}
            </div>
        );
    }
}

export default ZipCodeField;



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/address/zipcode-field.jsx
 **/